<div class="add-warehouse-modal" *transloco="let t; prefix: 'parts.modals'">

  <div class="add-warehouse-modal__header">
    <h3 class="add-warehouse-modal__title">{{ t('addWarehouse.title') }}</h3>
    <button type="button" class="add-warehouse-modal__close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <form class="add-warehouse-modal__fields" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="field-group">
      <label class="form-label">{{ t('fields.account') }} <span class="required">*</span></label>
      <app-account-selector (accountChanged)="onSelectAccount($event)" [isFilter]="false" [positionOffset]="'-90,15'"></app-account-selector>
      <app-form-error-message [isEnabled]="submitted && !selectedAccount" [errorMessage]="t('addWarehouse.accountRequired')"></app-form-error-message>
    </div>

    <div class="field-group">
      <label class="form-label">{{ t('addWarehouse.externalOrInHouse') }}<span class="required">*</span></label>
      <span ngbDropdown class="filter-dropdown" [autoClose]="true">
        <button type="button" class="btn form-control dropdown-toggle filter-input" ngbDropdownToggle [disabled]="isSaving">
          <div class="d-flex flex-row justify-content-between align-items-center">
            <span class="align-middle">{{ selectedTypeLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-custom">
          @for (type of warehouseTypes; track type) {
            <button type="button" class="btn btn-outline dropdown-item-custom" ngbDropdownItem (click)="selectType(type)">
              {{ warehouseTypeLabels[type] }}
            </button>
          }
        </div>
      </span>
    </div>

    <div class="field-group">
      <label class="form-label">{{ t('addWarehouse.warehouseName') }} <span class="required">*</span></label>
      <input type="text" formControlName="name" class="form-control" [placeholder]="t('placeholders.enterWarehouseName')">
      <app-form-error-message [control]="form.get('name')!" [errorMessage]="getErrorMessage('name')" [formSubmitted]="submitted"></app-form-error-message>
    </div>

    <div class="field-group">
      <label class="form-label">{{ t('fields.location') }} <span class="required">*</span></label>
      <input #locationInput type="text" formControlName="location" class="form-control" [placeholder]="t('placeholders.enterLocation')" autocomplete="off" (input)="onLocationTyped()">
      <app-form-error-message [control]="form.get('location')!" [errorMessage]="getErrorMessage('location')" [formSubmitted]="submitted"></app-form-error-message>
    </div>

    <div class="field-group">
      <label class="form-label">{{ t('fields.email') }} <span class="required">*</span></label>
      <input type="email" formControlName="email" class="form-control" [placeholder]="t('placeholders.enterEmailAddress')">
      <app-form-error-message [control]="form.get('email')!" [errorMessage]="getErrorMessage('email')" [formSubmitted]="submitted"></app-form-error-message>
    </div>

    <div class="field-group">
      <label class="form-label">{{ t('fields.phoneNumber') }} <span class="required">*</span></label>
      <input type="text" formControlName="phoneNumber" class="form-control" [placeholder]="t('placeholders.enterPhoneNumber')">
      <app-form-error-message [control]="form.get('phoneNumber')!" [errorMessage]="getErrorMessage('phoneNumber')" [formSubmitted]="submitted"></app-form-error-message>
    </div>
  </form>

  <div class="add-warehouse-modal__actions">
    <button type="button" class="cancel-btn" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="save-btn" [disabled]="!canSave" (click)="onSubmit()">
      @if (isSaving) {
        <span class="spinner-border"></span>
      } @else {
        <span>{{ t('actions.save') }}</span>
      }
    </button>
  </div>

</div>
